
import { z } from "zod";

export const SiteVisitReinspectionFaultValues = ["PARTNER", "REMI"] as const;
export const SiteVisitReinspectionFaultSchema = z.enum(SiteVisitReinspectionFaultValues);
export const SiteVisitReinspectionFault = SiteVisitReinspectionFaultSchema.enum;
export type SiteVisitReinspectionFault = (typeof SiteVisitReinspectionFaultValues)[number];
export const SiteVisitReinspectionFaultDisplayNames = { "PARTNER": "Partner",
"REMI": "Remi", } satisfies Record<SiteVisitReinspectionFault, string>;
